import Cookies from "js-cookie";

const isDevelopment = process.env.NODE_ENV === "development";

export const setCookie = (
  name: string,
  value: string,
  options?: Cookies.CookieAttributes
) => {
  const secureOptions = isDevelopment ? {} : { secure: true };

  Cookies.set(name, value, {
    sameSite: "strict",
    path: "/",
    ...secureOptions,
    ...options,
  });
};

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const removeCookie = (name: string) => {
  Cookies.remove(name);
};
